<template>
  <div class="support" :style="{ 'min-height': clientHeight + 'px' }">
    <div class="support-header">
      <div class="header-content">
        <!-- <h2 class="title">{{ $t("m.sedNav.supportTitle") }}</h2>
         -->
        <span class="nav-title">How can we help you?</span>

        <div class="search">
          <span class="search-icon"> </span>
          <span class="support-input">
            <input
              type="text"
              class="support-ipt"
              placeholder="Describe your issue"
              v-model="searchinpt"
              @keydown.enter="search()"
          /></span>
        </div>
      </div>
    </div>
    <div class="support-content">
      <div class="content-title">
        <span v-if="$t('m.lang') == 'zh'">浏览帮助主题</span>
        <span v-if="$t('m.lang') == 'en'">Browse help topics</span>
      </div>
      <article class="support-main">
        <dl class="support-list" v-for="(item, index) in faqList" :key="index">
          <dt class="support-title">
            <a :href="'##' + item.ulName" @click="lineOpen(item.ulName)"
              >{{ item.ulName }}
            </a>
            <span
              class="arrow"
              :class="{ active: titleActive == item.ulName ? true : false }"
            ></span>
          </dt>
          <div
            class="item-overflow"
            :style="{ 'margin-top': -52 * item.faqListUl.length + 'px' }"
            :class="{ active: titleActive == item.ulName ? true : false }"
          >
            <dd
              class="support-item"
              v-for="(items, index) in item.faqListUl"
              :key="index"
            >
              <router-link :to="`/support/` + items.value.replaceAll(` `,`-`).replaceAll(`/`,`&`) + '/'">{{
                items.value
              }}</router-link>
            </dd>
          </div>
        </dl>
      </article>
      <Freq :Frequently="Frequently"></Freq>
    </div>

    <div class="support-bottom-nav">
      <div class="sbn-title">
        <div class="title">Need more help?</div>
        <div class="underline">Try these next steps:</div>
      </div>
      <div class="sbn-container">
        <div class="tabs">
          <div class="tabs-container">
            <div class="title">Join our forum/Reddit</div>
            <div class="underline">
              Ask questions, find solutions, receive update notifications, and
              share your experiences.
            </div>
            <a class="btn" href="https://forum.skybox.xyz/">Join our forum</a>
            <a class="btn" href="https://www.reddit.com/r/SKYBOXVR/"
              >Join our Reddit</a
            >
          </div>
        </div>
        <div class="tabs">
          <div class="tabs-container">
            <div class="title">Contact us</div>
            <div class="underline">
              Describe your issue in details and submit a support ticket for
              further assistance.
            </div>
            <a class="btn" href="/submit-a-ticket">Submit a support ticket</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Freq from "../components/FreqPreview.vue";
export default {
  components: { Freq },
  data() {
    return {
      clientHeight: document.documentElement.clientHeight - 104,
      searchinpt: "",
      fullWidth: document.documentElement.clientWidth,

      Frequently: "",
      load: true,
      faqList: [],
      titleActive: "",
    };
  },

  created() {},
  mounted() {
    if (this.fullWidth > 767) {
      document.querySelector(".supportLi").style.color = "#fff";
    }
    // JSON.parse(this.$route.query)
    this.faqList = this.$route.query.faq;
    console.log(JSON.parse(this.faqList));
    this.Frequently = JSON.parse(this.$route.query.freq);
  },
  methods: {
    lineOpen(title) {
      if (title == this.titleActive) {
        this.titleActive = "";
      } else {
        this.titleActive = title;
      }
    },

    search() {
      if (this.$i18n.t("m.lang") == "en") {
        if (this.searchinpt != "") {
          this.$router.push({
            path: "/search",
            query: { search: this.searchinpt },
          });
        }
      } else {
        this.$router.push({
          path: "/search-zh",
          query: { search: this.searchinpt },
        });
      }
    },
    goContent(value) {
      this.$router.push({
        path: "/content",
        query: { title: value },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/support.scss";
</style>